import { render, staticRenderFns } from "./LowerThirdScroll.vue?vue&type=template&id=2db275c6"
import script from "./LowerThirdScroll.vue?vue&type=script&lang=js"
export * from "./LowerThirdScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports